/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { CardContext } from "./card";

const cardContentVariants = cva("--content", {
  variants: {
    size: {
      default: "p-4",
      sm: "p-3",
      lg: "p-5",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { size } = React.useContext(CardContext);

  return (
    <div
      ref={ref}
      className={cn(cardContentVariants({ size }), className)}
      {...props}
    />
  );
});
CardContent.displayName = "CardContent";

export { CardContent, cardContentVariants };
